import PropTypes from 'prop-types'
import cn from '../modules/cn'
import {
  CheckCircle,
  ExclamationCircle,
} from '../icons'

function Alert({
  title, success, children, errorMessages,
}) {
  return (
    <div
      className={cn(
        'flex rounded-md bg-yellow-50 p-4',
        success && 'bg-green-50',
      )}
    >
      <div className="flex">
        {!success && (<ExclamationCircle className="h-4 w-4 mr-2 text-yellow-800" />)}
        {success && (<CheckCircle className="h-4 w-4 mr-2 text-green-800" />)}
      </div>
      <div className="flex flex-col justify-center">
        {title && (
          <h3
            className={cn(
              'text-base leading-none font-medium font-display text-yellow-800',
              success && 'text-green-800',
            )}
          >
            {title}
          </h3>
        )}
        {(children || errorMessages) && (
          <div
            className={cn([
              'mt-2 text-sm text-yellow-700',
              success && 'text-green-700',
            ])}
          >
            {children && (<p>{children}</p>)}
            {errorMessages && errorMessages.length > 0 && (
              <ul className="list-disc pl-5 space-y-1">
                {errorMessages.map((errorMessage) => (
                  <li
                    key={errorMessage.title}
                    title={errorMessage.status && `Error Code for developers: ${errorMessage.status}`}
                  >
                    {errorMessage.title}
                  </li>
                ))}
              </ul>
            )}
          </div>
        )}
      </div>
    </div>
  )
}

Alert.propTypes = {
  title: PropTypes.string,
  children: PropTypes.string,
  success: PropTypes.bool,
  errorMessages: PropTypes.arrayOf(PropTypes.shape({
    status: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    title: PropTypes.string.isRequired,
  })),
}

Alert.defaultProps = {
  title: 'Something\'s wrong',
  children: null,
  success: false,
  errorMessages: null,
}

export default Alert
